import { render, staticRenderFns } from "./DocumentCardIterator.vue?vue&type=template&id=7b362b7e&scoped=true&"
import script from "./DocumentCardIterator.vue?vue&type=script&lang=js&"
export * from "./DocumentCardIterator.vue?vue&type=script&lang=js&"
import style0 from "./DocumentCardIterator.vue?vue&type=style&index=0&id=7b362b7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b362b7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VBtnToggle,VCol,VDivider,VIcon,VRow})
